import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-detalhe-pdf',
  templateUrl: './detalhe-pdf.component.html',
  styleUrls: ['./detalhe-pdf.component.scss'],
})
export class DetalhePdfComponent implements OnInit {

  @Input() pdfSrc: string;
  @Output() fechar = new EventEmitter();

  constructor() {}

  ngOnInit() {
    this.pdfSrc = this.pdfSrc.replace('http://', 'https://');
  }

  close() {
    this.fechar.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/detalhe-pdf/detalhe-pdf.component.ts